import PropTypes from "prop-types";
import React, { Component } from "react";
import "react-drawer/lib/react-drawer.css";

import { connect } from "react-redux";
import { Link } from "react-router-dom";

// Import menuDropdown
import ProfileMenu from "../TopbarDropdown/ProfileMenu";

import logo from "../../assets/images/logo.png";
import logoLightSvg from "../../assets/images/logo.svg";
import languges_world from "../../assets/images/icon/languages.png";
import Select from "react-select";
import api from "../../api";
import { withTranslation } from "react-i18next";
import { withRouter } from "react-router-dom";

import logoLightSvg2 from "../../assets/images/pizza-hut/pizza-hut-logo.svg";
import logoLightSvg3 from "../../assets/images/pizza-hut/pizza-hut-cap.png";
import { GetCompanyData } from "services/CompanyService";

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isSearch: false,
      open: false,
      position: "right",
      languages: [{ label: "English", value: 1 }],
      selectedLanguage: localStorage.getItem("lang_id") || 1,
      data: "",
      showLanguageDropdown: false, // New state to control visibility
      permissionChecked: false,
    };
    this.toggleMenu = this.toggleMenu.bind(this);
    this.toggleFullscreen = this.toggleFullscreen.bind(this);
    this.toggleLanguageDropdown = this.toggleLanguageDropdown.bind(this); // New toggle method
    this.handleClickOutside = this.handleClickOutside.bind(this); // Handle outside click
  }

  /**
   * Toggle sidebar
   */
  toggleMenu() {
    this.props.toggleMenuCallback();
  }

  toggleFullscreen() {
    if (
      !document.fullscreenElement &&
      /* alternative standard method */ !document.mozFullScreenElement &&
      !document.webkitFullscreenElement
    ) {
      // current working methods
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen();
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen();
      } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen(
          Element.ALLOW_KEYBOARD_INPUT
        );
      }
    } else {
      if (document.cancelFullScreen) {
        document.cancelFullScreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
      }
    }
  }

  componentDidMount = () => {
    this.getLanguageData();
  };

  getLanguageData = async () => {
    await api
      .get(`${process.env.REACT_APP_API_URL}/public/get-languages`)
      .then(res => {
        if (res?.data?.data?.length > 0) {
          localStorage.setItem("languages", JSON.stringify(res?.data?.data));
          this.setState({ languages: res?.data?.data || [] });
          if (!localStorage?.getItem("lang_id")) {
            localStorage.setItem("lang_id", 1);
          }
        }
      })
      .catch(err => {});
  };

  checkPermissionStatus = (link, action = "view") => {
    const roleWiseData = localStorage.getItem("roleWiseAccess")
      ? JSON.parse(localStorage.getItem("roleWiseAccess"))
      : [];

    if (!roleWiseData.length) return false;

    // normalize route (remove leading slash)
    const normalizedLink = link.replace(/^\/+/, "");

    const permission = roleWiseData.find(el => el.menu_link === normalizedLink);

    return Boolean(permission?.actions?.[action]);
  };

  fetchCompany = () => {
    GetCompanyData()
      .then(res => {
        let companyData = res?.data?.data || {};
        this.setState({ data: companyData });
      })
      .catch(err => {});
  };

  handleClickOutside(event) {
    if (
      this.languageDropdownRef &&
      !this.languageDropdownRef.contains(event.target) &&
      this.state.showLanguageDropdown
    ) {
      this.setState({ showLanguageDropdown: false });
    }
  }
  componentDidMount = () => {
    this.fetchCompany();
    this.getLanguageData();

    // Check if lang_id is already in localStorage
    const langId = localStorage.getItem("lang_id");
    if (langId) {
      // Apply class based on lang_id
      document.body.classList.add(`lang-${langId}`);
    }

    // Add event listener for outside clicks
    document.addEventListener("mousedown", this.handleClickOutside);
    const currentPath = location.pathname;
    if (
      currentPath == "/create-job-new" ||
      currentPath.includes("/edit-job-new")
    ) {
      console.log("USER HELLO PATH", currentPath);
      this.setState(prevState => ({
        showLanguageDropdown: false,
      }));
    } else {
      this.setState(prevState => ({
        showLanguageDropdown: false,
      }));
    }

    const interval = setInterval(() => {
      const access = localStorage.getItem("roleWiseAccess");
      if (access) {
        clearInterval(interval);
        this.setState({ permissionChecked: true });
      }
    }, 200);
  };

  componentWillUnmount() {
    // Clean up the event listener
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  toggleLanguageDropdown() {
    if (window.innerWidth <= 767) {
      this.setState(prevState => ({
        showLanguageDropdown: !prevState.showLanguageDropdown,
      }));
    }
  }
  handleChange = selectedOption => {
    this.setState({
      selectedLanguage: selectedOption?.value,
    });
    localStorage.setItem("lang_id", selectedOption?.value);

    // Remove the previous language class
    document.body.classList.remove(`lang-${this.state.selectedLanguage}`);

    // Add the new language class
    document.body.classList.add(`lang-${selectedOption?.value}`);

    this.props.i18n.changeLanguage(selectedOption?.alias);
    window.location.reload();
  };

  render() {
    const { t, location } = this.props;
    return (
      <React.Fragment>
        <header id="page-topbar">
          <div className="navbar-header">
            <div className="d-flex header-name align-items-center">
              <div className="navbar-brand-box d-lg-none d-md-block">
                {/* <Link to="/" className="logo logo-dark">
                  <span className="logo-sm">
                    <img src={logo} alt="" height="22" />
                  </span>
                </Link> */}

                <Link to="/" className="logo logo-light neuro-logos">
                  <span className="logo-sm">
                    <img
                      src={this.state.data?.company_logo}
                      height="22"
                      width="auto"
                    />
                  </span>
                </Link>

                <Link to="/" className="logo logo-light">
                  <span className="logo-lg text-center   pizza-logo">
                    <img
                      src={this.state.data?.company_logo}
                      height="30"
                      // width="180"
                    />
                  </span>
                </Link>
                <Link to="/" className="logo logo-light">
                  <span className="logo-lg text-center   pizza-logo2">
                    <img
                      src={this.state.data?.company_logo}
                      height="30"
                      // width="180"
                    />
                  </span>
                </Link>
              </div>

              <button
                type="button"
                onClick={this.toggleMenu}
                className="btn btn-sm px-3 font-size-16 header-item"
                id="vertical-menu-btn"
              >
                <i className="fa fa-fw fa-bars"></i>
              </button>

              {this.state.permissionChecked &&
                this.checkPermissionStatus("dashboard", "view") && (
                  <div className="header-page-name">
                    <h5 className="mb-0 heading-one">
                      {t(`Dashboard.Dashboard`)}
                    </h5>
                  </div>
                )}
            </div>
            <>
              <div className="d-flex profile-navbar">
                <div
                  className="mobile-languages"
                  onClick={this.toggleLanguageDropdown}
                >
                  <img src={languges_world} alt="languges_world" />
                </div>

                <div
                  className={`login-dropdown-language selectlang ${
                    this.state.showLanguageDropdown ? "show" : ""
                  }`}
                >
                  <Select
                    id="select"
                    options={this.state.languages}
                    value={this.state.languages?.find(
                      el => el?.value === parseInt(this.state.selectedLanguage)
                    )}
                    onChange={this.handleChange}
                    placeholder="Select Language"
                    aria-labelledby="select"
                  />

                  {/* /**rohit-code */}
                  {/* <Select
                    id="select"
                    options={this.state.languages}
                    value={this.state.languages?.find(
                      el => el?.value === parseInt(this.state.selectedLanguage)
                    )}
                    onChange={selectedOption => {
                      this.setState({
                        selectedLanguage: selectedOption?.value,
                      });
                      localStorage.setItem("lang_id", selectedOption?.value);
                      window.location.reload();
                    }}
                    placeholder="Select Language"
                  /> */}
                </div>

                <ProfileMenu />
              </div>
            </>
          </div>
        </header>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = state => {
  const { layoutType } = state.Layout;
  return { layoutType };
};

export default connect(mapStatetoProps)(withTranslation()(Header));

Header.propTypes = {
  t: PropTypes.any,
  toggleMenuCallback: PropTypes.any,
};
